import React, { useEffect } from "react";

export default function FullLayout({ children }) {
  return (
    <>{children}</>
  );
};